import { type SystemPreferenceMap } from '@webapp/platform/iam/business-logic/interfaces/ISystemPreferencesRepository'
import { SystemPreferencesRepository } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository'
import { systemPreferencesKeys } from '@webapp/platform/iam/data-access/repositories/SystemPreferencesRepository/queryKey.factory'

export const systemPreferenceQueryConfig = {
  // ['system-preferences', key]
  // Resolves `null` for a preference that was never set, so each reader keeps
  // its own default (`data?.value ?? DEFAULT`) and `isError` only ever means a
  // real failure.
  getValue: <K extends keyof SystemPreferenceMap>(key: K) => ({
    queryKey: systemPreferencesKeys.byKey(key),
    queryFn: () => SystemPreferencesRepository.getSystemPreference(key),
  }),
}
